import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { Toaster } from 'sonner';

import { EnvironmentBanner } from '~/components/common/EnvironmentBanner';
import { ErrorScreen } from '~/components/common/ErrorScreen';
import { NotFoundScreen } from '~/components/common/NotFoundScreen';
import { TooltipProvider } from '~/components/ui/tooltip';

export interface RouterContext {
  queryClient: QueryClient;
}

function RootErrorScreen(props: ErrorComponentProps): React.ReactNode {
  return (
    <div className="bg-background min-h-screen flex items-center justify-center">
      <ErrorScreen {...props} />
    </div>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFoundScreen,
  errorComponent: RootErrorScreen
});

function RootLayout(): React.ReactNode {
  return (
    <TooltipProvider delay={400}>
      <div className="bg-background text-foreground min-h-screen">
        <EnvironmentBanner />
        <Outlet />
      </div>
      <Toaster />
    </TooltipProvider>
  );
}
